// 리퍼럴 & 리워드 프로그램(#515 Phase 1, PR #520) 노출 여부.
// 백엔드 API(/referral/*, /reward/*)가 운영에 배포되기 전까지 운영 빌드에서 잠근다
// — .env.production=false, .env.development=true. 미설정 시 잠김(안전 기본값).
// 잠금 범위: /my/rewards 라우트·마이페이지 메뉴, ?ref= 어트리뷰션 캡처,
// 장바구니 추천코드 입력·자동 적용, 회원가입 referralCode 연결.
export const REFERRAL_REWARDS_ENABLED = process.env.REACT_APP_FEATURE_REFERRAL_REWARDS === 'true';

// Journey 단계 미리보기 바(임시 QA 도구, web#551) 노출 여부.
// dev 사이트에서 샘플 데이터로 ①~⑤ 단계를 확인하기 위한 것 —
// .env.development=true, .env.production=false. 미설정 시 잠김(안전 기본값).
// prod 출시 전 미리보기 바 자체를 제거하면 이 플래그도 함께 정리한다.
export const JOURNEY_STAGE_PREVIEW_ENABLED = process.env.REACT_APP_FEATURE_JOURNEY_STAGE_PREVIEW === 'true';

// 국내카드(한국 발급 카드) 등록·표시 노출 여부. 백엔드 국내카드 스위치(payletter.domestic.enabled)와 같이 움직인다
// — .env.development=true, .env.production=false. 미설정 시 잠김(안전 기본값).
// 잠금 범위: 마이페이지 카드 등록(가계약용)의 "한국 발급 카드" 선택지.
// (이미 등록된 국내카드의 표시는 스위치와 무관 - 백엔드가 꺼진 환경에선 목록에 내려주지 않는다.)
export const DOMESTIC_CARD_ENABLED = process.env.REACT_APP_FEATURE_DOMESTIC_CARD === 'true';

// 가계약 신청(2단계)에서 한국 발급 카드 등록·선택 노출 여부. 백엔드 국내카드 가계약 수락 결제(백엔드 #1928)가
// 배포된 환경에서만 켠다(없는 환경에서는 백엔드가 신청 화면 카드 목록에서 국내카드를 빼 2단계에서 등록해도 안 보인다).
// .env.development=true, .env.production=false. 미설정 시 잠김(안전 기본값). DOMESTIC_CARD_ENABLED 도 켜져 있어야 한다.
export const DOMESTIC_CARD_APPLICATION_ENABLED =
  DOMESTIC_CARD_ENABLED && process.env.REACT_APP_FEATURE_DOMESTIC_CARD_APPLICATION === 'true';

// 방구해줘 결제에서 한국 발급 카드 선택 노출 여부. 백엔드 방구해줘 국내카드 결제(백엔드 #1929)가 배포된 환경에서만 켠다.
// .env.development=true, .env.production=false. 미설정 시 잠김(안전 기본값). DOMESTIC_CARD_ENABLED 도 켜져 있어야 한다.
// 꺼져 있으면 신청 요청에 cardProvider 를 싣지 않는다(기존 요청과 똑같음 - 백엔드는 해외카드로 처리).
export const DOMESTIC_CARD_REQUEST_ROOM_ENABLED =
  DOMESTIC_CARD_ENABLED && process.env.REACT_APP_FEATURE_DOMESTIC_CARD_REQUEST_ROOM === 'true';
